import { render } from "./Play.vue?vue&type=template&id=3220a0ce"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
script.render = render

export default script